import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  CUSTOMER_DATA_FETCH,
  CUSTOMER_DATA_FETCH_SUCCESS,
  CUSTOMER_DATA_UPDATE,
  CUSTOMER_DATA_UPDATE_FINISHED,
} from './constants';

const initialState = fromJS({
  isFetching: false,
  data: null,
  updateCustomerFinished: false,
})

export const reducer = handleActions({
  [CUSTOMER_DATA_FETCH]: (state) => (
    state
      .set('isFetching', true)
      .set('data', null)
  ),

  [CUSTOMER_DATA_FETCH_SUCCESS]: (state, action) => (
    state
      .set('isFetching', false)
      .set('data', fromJS(action.payload.data))
  ),

  [CUSTOMER_DATA_UPDATE]: (state) => (
    state
  ),

  [CUSTOMER_DATA_UPDATE_FINISHED]: (state) => (
    state
      .set('updateCustomerFinished', true)
  ),
}, initialState);


export default reducer
